// @ts-nocheck


import React, { useState } from 'react'
import { FaRegQuestionCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../../../ApiClient/GetApi';
import { PostApi } from '../../../../ApiClient/PostApi';
import { Loader2 } from '../../../loader/Loader';
import { error_toaster } from '../../../toaster/Toaster';
import Header from '../../layout/Header'
import LeftBar from '../leftBar/LeftBar'

export default function CompanyDetail() {
    const navigate = useNavigate()
    const companies = useFetch("booking/get_all_companies");
    const { data } = useFetch(`booking/booking_detail/${localStorage.getItem("orderId")}`);
    const [companyPrice, setCompanyPrice] = useState(0);
    const [companyId, setCompanyid] = useState("")
  
   
    const [loading, SetLoading] = useState(false)
    const OnChange = async (id) => {
        setCompanyid(id)
        const res = await PostApi("booking/company_select", {
            companyId: id
        });

        if (res.data.message === "0") {
            error_toaster(res.data.message);
        }
        else {
            setCompanyPrice(res.data.data.tax);
        }

    }

    const continue_order = async () => {
        if (companyId === "") {
            error_toaster("Please Select atleast one logistic company!");
            return false;
        }
        SetLoading(true)
        const res = await PostApi("booking/after_company_selection", {
            companyId: companyId,
            orderId: localStorage.getItem("orderId")
        });
        if (res.data.status === "0") {
            SetLoading(false)
            error_toaster(res.data.message);
        }
        if (res.data.status === "1") {
            SetLoading(false);
            navigate('/supplier_details')
        }

    }
    return (
        <>
            <section className="font-soehne">
                <Header />
                <section className="lg:py-20 py-12 xl:w-5/6 w-11/12 mx-auto lg:grid lg:grid-cols-12">
                    <LeftBar />
                    <>
                        {
                            loading ? <Loader2 /> : <>
                                <div className="xl:col-span-9 lg:col-span-8 bg-white py-6 sm:px-8 px-4 space-y-8">
                                    <div className=''>
                                        <div className="[&>button>div]:border-none flex gap-x-3">
                                            <fieldset className="flex flex-col gap-4" id="radio">
                                                <legend className="font-normal sm:text-xl text-lg px-10 text-black text-opacity-60 flex items-center gap-x-3">
                                                    Please select your logistic company
                                                    <div className="max-w-[24px]">
                                                        <FaRegQuestionCircle
                                                            size={24}
                                                            className="md:block hidden text-black text-opacity-60"
                                                        />
                                                    </div>
                                                </legend>
                                                <div className="flex items-center px-10 justify-center gap-x-6 mt-3 ml-0.5">

                                                    {
                                                        companies?.data?.data?.map((company) => (
                                                            <div className="  px-4 w-[180px] py-6 rounded-lg bg-themeGray" key={company.id}>
                                                                <div className="flex items-center gap-2">
                                                                    <input type="radio" name="company" value={company.id} onChange={(e) => OnChange(e.target.value)} />
                                                                    <label>{company.name}</label>
                                                                </div>

                                                                <p className="text-sm text-themeRed text-center">(R {company.tax})</p>
                                                            </div>
                                                        ))
                                                    }



                                                </div>

                                            </fieldset>
                                        </div>

                                    </div>
                                    <div className='grid grid-cols-2 items-center'>

                                        <div className=' m-10 p-10 bg-themeGray rounded-lg'>
                                            <div className=' px-2 '>
                                                <ul className="space-y-4">
                                                    <li className="flex justify-center items-center gap-x-14">
                                                        <h5 className="font-medium text-base text-black text-opacity-40">
                                                            Order Total Price
                                                        </h5>
                                                        <h6 className="text-base font-semibold">R {data?.data?.order?.totalPrice + parseInt(companyPrice)}</h6>
                                                    </li>
                                                </ul>

                                            </div>
                                        </div>
                                        <div className=''>
                                            <button onClick={continue_order} className='py-3 px-10 bg-themeBlue text-white rounded border border-themeBlue hover:text-themeBlue hover:bg-white'>Contiue with Order</button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </>
                </section>
            </section>
        </>
    )
}
